
//车场管理
const ParkSet = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/parkset.vue')
const AreaList = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/arealist.vue')
const ParkingAreaList = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/parkingArea.vue')
const IoRecord = () => import(/*webpackChunkName:'operation'*/"@/page/operation/roadsideManagement/ioRecord.vue")
const IntellidataDeviceIORecord = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/intellidataDeviceIORecord.vue')
const OrderRecord = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/orderRecord.vue')
const DentalMachineRecord= () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/dentalMachineRecord.vue')
const OrderDetail = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideManagement/order-detail/order-detail.vue')

const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const roadsideManagement={
    path: '/main/park',
    name: '道路管理',
    component: RouteTemp,
    meta: {
        requireAuth: true,
    },
    children: [{
        path: '/main/park/parkingArea',
        name: '停车区域管理',
        component: ParkingAreaList,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/park/area',
        name: '泊位段管理',
        component: AreaList,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/park/parkset',
        name: '泊位管理',
        component: ParkSet,
        children: [],
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/iorecord/iorecordlist',
        name: '进出记录',
        component: IoRecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/order/all',
        name: '订单管理',
        component: OrderRecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/iorecord/intellidataDeviceIorecordList',
        name: '高位视频进出记录',
        component: IntellidataDeviceIORecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/iorecord/dental-machine-record',
        name: '路牙进出记录',
        component: DentalMachineRecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path: '/main/order/detail',
        name: '订单详情',
        component: OrderDetail,
        meta: {
            requireAuth: true,
        },
    }
    
]
}